import React from 'react'
import PropTypes from 'prop-types'

import styles from './Icon.css'

export const GLYPHS = [
    'bars',
    'filter',
    'info',
    'notification',
    'player',
    'stats',
    'vehicle',
    'warning',
]

const propTypes = {
    glyph: PropTypes.oneOf(GLYPHS).isRequired,
}

class Icon extends React.PureComponent {
    render() {
        const classNameGlyph = styles[this.props.glyph]

        return (
            <span className={classNameGlyph} />
        )
    }
}

Icon.propTypes = propTypes

export default Icon



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Icon/Icon.jsx